<template>
  <div class="main-container" :class="colorMode === 'dark' ? 'dark-block' : ''">
    <h2>Looking for your next African investment?</h2>
    <p>
      Cut through the noise by using our Virtual Deal Rooms as a digital on-ramp
      to opportunities that have been pre-qualified by our partners. Browse live
      deals or register to be kept informed of new opportunities.
    </p>
    <div class="action-wrap">
      <a
        @click="openLink"
        class="cta-button"
        :class="colorMode === 'light' ? 'medium-button' : ''"
        >Engage with African businesses</a
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'de-investors',
  props: {
    colorMode: {
      type: String,
    },
  },
  methods: {
    openLink() {
      this.$ga.event({
        eventCategory: 'Click',
        eventAction: 'Conversion',
        eventLabel: 'DE Investor Block',
      })
      this.$gtag.event('Conversion', {
        'event_category': 'Click',
        'event_label': 'DE Investor Block',
      })
      this.$router.push({ path: '/matching/marketplaces' })
    },
  },
}
</script>
